export default "__VITE_ASSET__BZhdwQPU__"